import { render, staticRenderFns } from "./DesconocimientoConsumo.vue?vue&type=template&id=5cdd37a9"
import script from "./DesconocimientoConsumo.vue?vue&type=script&lang=js"
export * from "./DesconocimientoConsumo.vue?vue&type=script&lang=js"
import style0 from "./DesconocimientoConsumo.vue?vue&type=style&index=0&id=5cdd37a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports